import { ApiRoutes, AppPaginationOptions, QueryError, WithPagination } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { DnsRecord, DnsRecordFormFields, DnsRecordsQueryKeys } from '@/modules/DnsRecords';

export const useGetAllDnsRecordsQuery = (paginationOptions: AppPaginationOptions, search?: string) =>
  buildQuery<WithPagination<DnsRecord>, QueryError>([DnsRecordsQueryKeys.GetAll, { ...paginationOptions, search }], async () => {
    const { data } = await apiExecutor.get<WithPagination<DnsRecord>>(ApiRoutes.DnsRecords, {
      params: { ...paginationOptions, search }
    });
    return data;
  });

export const useGetOneByIdDnsRecordsQuery = (dnsRecordId: string) =>
  buildQuery<DnsRecord, QueryError>([DnsRecordsQueryKeys.GetOneById, dnsRecordId], async () => {
    const { data } = await apiExecutor.get<DnsRecord>(ApiRoutes.DnsRecordsById.replace(':dnsRecordId', dnsRecordId));
    return data;
  });

export const useCreateDnsRecordsMutation = () =>
  buildMutation<DnsRecord, QueryError, DnsRecordFormFields>([DnsRecordsQueryKeys.Create], async (postData) => {
    const { data } = await apiExecutor.post<DnsRecord>(ApiRoutes.DnsRecords, {
      ...postData,
    }, { params: { teamId: localStorage.getItem('currentTeamId') } });
    return data;
  });

export const useEditDnsRecordsMutation = (dnsRecordId: string) =>
  buildMutation<DnsRecord, DnsRecordFormFields, QueryError>([DnsRecordsQueryKeys.Edit, dnsRecordId], async (postData) => {
    const { data } = await apiExecutor.patch<DnsRecord>(ApiRoutes.DnsRecordsById.replace(':dnsRecordId', dnsRecordId), {
      ...postData
    });
    return data;
  });

export const useDeleteDnsRecordsMutation = (dnsRecordId: string) =>
  buildMutation<void, QueryError, void>([DnsRecordsQueryKeys.Delete, dnsRecordId], async () => {
    await apiExecutor.delete<void>(ApiRoutes.DnsRecordsById.replace(':dnsRecordId', dnsRecordId));
  });

export const useAutocompleteDnsRecordsQuery = (params: { query: string; includedIds?: string[]; }) =>
  buildQuery<Pick<DnsRecord, 'id' | 'name' | 'apiProvider'>[], QueryError>(
    [DnsRecordsQueryKeys.Autocomplete, params],
    async () => {
      const { data } = await apiExecutor.get<Pick<DnsRecord, 'id' | 'name' | 'apiProvider'>[]>(ApiRoutes.DnsRecordsAutocomplete, {
        params: { q: params.query, includedIds: params?.includedIds?.length ? String(params.includedIds) : undefined, }
      });
      return data;
    }
  );

export const useBreadcrumbDnsRecordsQuery = (dnsRecordId: string) =>
  buildQuery<string, QueryError>([DnsRecordsQueryKeys.Breadcrumb, dnsRecordId], async () => {
    const { data } = await apiExecutor.get<string>(ApiRoutes.DnsRecordsBreadcrumb.replace(':dnsRecordId', dnsRecordId));
    return data;
  });
